<template>
  <div class="home">
    <el-container class="home-container">
      <el-aside width="200px" class="sidebar">
      <el-menu
      >
        <router-link to="/"><el-menu-item index="1-0"><i class="el-icon-s-home"></i>首页</el-menu-item></router-link>
        <router-link to="/users"><el-menu-item index="1-1"><i class="el-icon-user"></i>用户管理</el-menu-item></router-link>
        <router-link to="/categories"><el-menu-item index="1-2"><i class="el-icon-s-order"></i>分类管理</el-menu-item></router-link>
        <router-link to="/templates"><el-menu-item index="1-3"><i class="el-icon-s-order"></i>模版管理</el-menu-item></router-link>
        <router-link to="/resumes"><el-menu-item index="1-4"><i class="el-icon-s-order"></i>简历管理</el-menu-item></router-link>
        <router-link to="/orders"><el-menu-item index="1-5"><i class="el-icon-s-order"></i>订单管理</el-menu-item></router-link>
        <router-link to="/balances"><el-menu-item index="1-6"><i class="el-icon-s-order"></i>代金券管理</el-menu-item></router-link>
        <router-link to="/tokens"><el-menu-item index="1-7"><i class="el-icon-s-order"></i>Token 管理</el-menu-item></router-link>
      </el-menu>
      </el-aside>
      <el-container>
        <el-header style="text-align: right; font-size: 12px">
          <el-dropdown v-if="user.isLogin">
            <el-button type="primary" plain icon="el-icon-setting">{{user.data.userName}}</el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>查看</el-dropdown-item>
                <el-dropdown-item>新增</el-dropdown-item>
                <el-dropdown-item  @click.prevent="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import axios from 'axios'
import { useStore } from '../store/index'
import { useRouter } from 'vue-router'
export default defineComponent({
  name: 'Index',
  setup() {
    const store = useStore()
    const router = useRouter()
    const user = computed(() => store.state.user)
    const logout = () => {
      axios.get('/api/logout').then(() => {
        store.commit('logout')
        router.push('/login')
        window.location.reload()
      })
    }
    return {
      user,
      logout
    }
  }
});
</script>
<style lang="scss">
@import "~element-plus/packages/theme-chalk/src/common/var";
body {
  margin: 0;
}
.home-container {
  min-height: 100vh;
}
.sidebar {
  background-color: rgb(48, 65, 86);
}
.home-container {
  .el-menu {
    background-color: rgb(48, 65, 86);
    .el-menu-item, .el-sub-menu .el-sub-menu__title {
      color: rgb(191, 203, 217);
      &:hover {
        background-color: #1f2d3d!important;
      }
      &.is-active {
        color: rgb(64, 158, 255);
      }
      a {
        color: rgb(191, 203, 217);
        text-decoration: none;
      }
    }
  }
}
</style>
